<div *ngIf="staticContent" [innerHTML]="staticContent.content"></div>
<app-not-found *ngIf="!staticContent"></app-not-found>